import { createContext, useContext } from 'react';

const OutreachScopeContext = createContext({
  scope: 'per_campus',
  isOrgWide: false,
  loading: true,
  setScope: () => {},
});

export function useOutreachScope() {
  return useContext(OutreachScopeContext);
}

export default OutreachScopeContext;
